import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";

import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import CheckoutItems from "../components/CheckoutItems";
import CheckoutSummary from "../components/CheckoutSummary";
import PersonalInfo from "../components/PersonalInfo";
import GstinSection from "../components/GstinSection";
import ShippingAddressSection from "../components/ShippingAddressSection";
import CheckoutFooterInfo from "../components/CheckoutFooterInfo";
import AddressModal from "../components/AddressModal";
import Footer from "../../../../components/Footer/Footer";

import { fetchCheckout } from "../redux/checkoutSlice";
import { createAddress, getAddress } from "../../../../pages/Account/Profile/addressSlice";
import { fetchUserProfile } from "../../../../pages/Account/Profile/profileSlice";
import { useCheckout } from "../hooks/useCheckout";

import "../styles/CheckoutPage.css";

const CheckoutPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [gstinEnabled, setGstinEnabled] = useState(false);

  const [gstinData, setGstinData] = useState({
    registrationNumber: "",
    companyAddress: "",
  });

  const [defaultAddr, setDefultAddr] = useState(null);
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const gstInputRef = useRef(null);

  const [loading, setLoading] = useState(false);

  const { checkoutData } = useSelector((state) => state.checkout);
  const { data: addressdata = [] } = useSelector((state) => state.address);
  const { data: profileData } = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(fetchCheckout());
    dispatch(getAddress());
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const { handlePlaceOrder } = useCheckout(
    defaultAddr,
    gstinEnabled,
    gstinData,
    checkoutData,
    navigate
  );

  // CONTINUE BUTTON HANDLER
  const handleContinueClick = async () => {
    if (loading) return;

    const gstNumber = gstinData?.registrationNumber?.trim();

    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    if (gstinEnabled) {
      if (!gstNumber) {
        toast.error("Please input GSTIN Registration No");
        focusGST();
        return;
      }

      if (!gstRegex.test(gstNumber)) {
        toast.error("Please input GSTIN Registration No");
        focusGST();
        return;
      }
    }

    // helper function
    function focusGST() {
      if (gstInputRef.current) {
        gstInputRef.current.focus();
        gstInputRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }

    if (!defaultAddr) {
      toast.error("Please select shipping address");
      return;
    }

    setLoading(true);

    try {
      await handlePlaceOrder();
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster position="top-right" />

      <Breadcrumbs
        paths={[
          { label: "Cart", to: "/cart" },
          { label: "Checkout", to: "" },
        ]}
      />

      <div className="root-title-chk">
        <h2 className="title_chk">Checkout</h2>
      </div>

      <div className="checkout-container_chk">
        <CheckoutItems checkoutData={checkoutData} />

        {checkoutData?.data?.items?.length > 0 && (
          <div className="checkout-left_ck">

            <CheckoutSummary checkoutData={checkoutData} items={checkoutData?.data?.items || []} />

            <PersonalInfo profileData={profileData} />

            <GstinSection
              gstinEnabled={gstinEnabled}
              setGstinEnabled={setGstinEnabled}
              gstinData={gstinData}
              setGstinData={setGstinData}
              ref={gstInputRef}
            />

            <ShippingAddressSection
              addressdata={addressdata}
              selectedAddressId={selectedAddressId}
              setSelectedAddressId={setSelectedAddressId}
              setDefultAddr={setDefultAddr}
              setShowAddAddressModal={setShowAddAddressModal}
            />

            <div className="root_track">
              <button
                onClick={handleContinueClick}
                className="payment-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="btn-spinner"></span>
                    Processing...
                  </>
                ) : (
                  "CONTINUE TO PAYMENT"
                )}
              </button>
            </div>

            <CheckoutFooterInfo />
          </div>
        )}
      </div>

      {showAddAddressModal && (
        <AddressModal
          setShowAddAddressModal={setShowAddAddressModal}
          createAddress={createAddress}
          getAddress={getAddress}
        />
      )}

      <Footer />
    </>
  );
};

export default CheckoutPage;